import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { getDetailsFromUrl } from '../../../services/blueprint'
import { invokeGetService, setFocusElement, toggleRightDrawer, invokePostService, setReRender, handleSnackBar, openTransactionSelectorForSimulation } from "../../../store/global/actions"
import { getRightDrawerStatus, getReRender, getTransactionSelectorForSimulation, getElementOnFocus } from "../../../store/global/selectors"
import SimulationSpeedDial from '../../pages/blueprint/SimulationSpeedDial'
import { useParams, useHistory } from 'react-router-dom';
import LoaderWithProgress from '../../../components/atoms/loader/LoaderWithProgress';
import { labelAttributes, eventAttributes, disabledEventAttributes, nestedTransactionLabelConfig, translabelAttributes, dragHandler, endPointLabelAttributes, endpointRectangleConfig, disabledNestedTransactionLabelConfig, disabledEndpointRectangleConfig } from '../../../config/clusterlets'
import SingleTransactionSelector from './SingleTransactionSelector'
import { Button } from "@material-ui/core";
import TestCaseLists from "./TestCaseLists";
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { Alert } from "@material-ui/lab";
import { getTestcaseNameFromURL } from "../../../utils/commonUtils";
import watch from "redux-watch";
import store from "../../../store";
const { Raphael } = require("react-raphael");
const { default: ImgGrid } = require("../bluePrintComponents/DataFlow/images/grid.gif");

const Simulation = () => {
  // console.log("-------------------Simulaton------------------------")
  const { search, pathname } = useLocation();
  const testcaseId = getTestcaseNameFromURL(search)
  const history = useHistory();

  let paper = null;
  const dispatch = useDispatch()
  let nodes = []
  let nodeWidth = 100
  let nodeHeight = 100
  let transactions = []
  let childTransactions = []
  let invokedTransactions = []
  const [simulationData, setSimulationData] = useState(null)
  let events = []
  const widthOfNode = 200
  let drawnVerticalLines = []
  let verticalLineMinHeight = 2000
  let offsetDistance = 120;
  let drawnTrs = [];
  let clickEvent = null
  let mouseMoveEvent = null
  let mouseUpEvent = null
  let drawnEvents = []
  let drawnChildTransactions = [];
  let drawnInvokedTransactions = [];
  let drawnEndpoints = [];
  let networks = [];
  let appendHeight = 500;
  const endpoint_width = 100;

  const [isExpanded, setExpanded] = useState(false)
  const [testcasesforList, setTestcasesforList] = useState([])
  const [activeTestsuite, setActiveTestsuite] = useState(null);
  const [previousTestcaseId, setPreviousTestcaseId] = useState(null);

  const { entityId } = getDetailsFromUrl();


  const reRender = useSelector(getReRender);
  const { transaction } = useParams()
  const [isLoading, setIsLoading] = useState(false)
  const [canvasHeight, setCanvasHeight] = useState(2000); // Initial height
  const transactionSelectorStatus = useSelector(getTransactionSelectorForSimulation)
  //const transactionPaperStatus = useSelector(getPaperReadyForTransactionStatus)
  const [transactionPaperStatus, setTransactionPaperStatus] = useState(false)
  const [simPaper, setPaper] = useState(null)
  const [canvasEl, setCanvasEl] = useState(null)
  const [lastDrawnObject, setLastDrawnObject] = useState(null)
  const [newTransactionOrder, setNewTransactionOrder] = useState(null)
  const [drawnTransactions, setDrawnTransactions] = useState([])
  const [testsuites, setTestsuites] = useState([])
  const elementOnFocus = useSelector(getElementOnFocus);
  const rightDrawerStatus = useSelector(getRightDrawerStatus);
  // console.log({rightDrawerStatus})

  useEffect(() => {
    drawTransaction(simPaper, canvasEl)
  }, [transactionPaperStatus])

  const styles = {
    container: {
      margin: '90px 0px 0px',
      padding: '0px 15px',
      width: '100%',
      height: '100%',
      position: 'relative'
    },
    canvas: {
      backgroundImage: `url(${ImgGrid})`,
      // overflow: 'scroll',
      border: '2px solid #ccc',
      height: canvasHeight,
      //'-webkit-transform-origin': '0 0',
      width: 2000,
    },
    twoColumnLayout: {
      display: 'flex',
      gap: isExpanded ? '0' : '2rem'
    },
    expCollapseBtn: {
      background: 'white',
      display: 'flex',
      gap: '1rem',
      alignItems: 'center',
      position: 'fixed',
      top: '100px',
      right: '2rem',
      zIndex: 1000,
      boxShadow: '0px 0px 10px rgba(0,0,0,0.1)',
      textTransform: 'capitalize'
    },
    createTestcaseContainer: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '1rem'
    }
  };

  // Default use effect
  useEffect(() => {
    if (previousTestcaseId !== testcaseId || reRender !== 0) {
      initiateRendering()

    }
  }, [reRender, transaction, testcaseId]);


  useEffect(() => {
    if (testsuites) {
      setActiveTestsuite(testsuites.find(item => item._id === entityId))
    }
  }, [testsuites])


  // Initiate process
  const initiateRendering = () => {
    try {
      
    
    setIsLoading(true)
    getSimulationDetails().then(([constructsResponse, testcaseResponse, testCaseTransactions]) => {
      setIsLoading(false)
      setTestsuites(constructsResponse?.data?.testSuites)
      networks = constructsResponse?.data?.networks ? constructsResponse?.data?.networks : [];

      if (testcaseResponse?.status === false || !testcaseResponse) {
        return false
      }
      const simTransactions = testcaseResponse.data?.testcaseTransactions?.sort((a, b) => a.order - b.order) || []
      const testcaseDelegates = testcaseResponse.data?.testcase?.delegates || [];
      const clusterlets = constructsResponse?.data?.clusterlets || []

      setSimulationData({ id: testcaseResponse.data.testcase._id, name: testcaseResponse.data.testcase.name, description: testcaseResponse.data.testcase.description })

      preparePaper().then(tmp_paper => {
        paper = tmp_paper

        const filteredSimulationTransactions = simTransactions.filter(sTransaction => !sTransaction.parent_id) || [];
        filteredSimulationTransactions.sort((a, b) => a.order - b.order);

        prepareSimulatorNode()
        prepareDelegates({
          delegates: testcaseDelegates, 
          clusterlets , 
          testCaseTransactions: testCaseTransactions?.data || []
        })
        prepareEvents({
          simulationTransactions: simTransactions, 
          filteredSimulationTransactions, 
          simulationDelegates: testcaseDelegates, 
          allTransactions: constructsResponse.data?.transactions || [], 
          allEvents: constructsResponse.data?.events || [], 
          allClusterlets: clusterlets
        })
        prepareTransactions({
          simulationTransactions: simTransactions, 
          allTransactions: constructsResponse.data?.transactions || [], 
          filteredSimulationTransactions
        })
        prepareChildTransactions({
          simulationTransactions: simTransactions ,
          allTransactions: constructsResponse.data?.transactions || []
        });
        prepareInvokedTransactions({
          simulationTransactions: simTransactions,
          allTransactions: constructsResponse?.data?.transactions || []
        })
        renderEvents()
        renderEndpoints()
        renderTransactions()
        renderChildTransactions(testcaseResponse.data.testcase.name);
        renderInvokedTransactions(testcaseResponse.data.testcase.name);
        renderNodes()
        attachTransactionDragHandlers()
        bringEventToTop()
        bringEndpointsToTop()
      })

    })

    } catch (error) {
      console.error("Rendering testsuite failed. ",error);
      return null;
    }
  }

  const getTestcasesForListing = (testcases) => {
    const { entityId } = getDetailsFromUrl()
    const filteredTestcases = testcases?.filter((item) => item.testsuite_id === entityId)
    return filteredTestcases;
  }


  // Prepare paper
  const preparePaper = () => {

    return new Promise((resolve, reject) => {

      // if (paper != null) {
      //   reject(false)
      // }

      const canvasEl = document.getElementById('simulation_container');
      if (canvasEl) {
        let tmp_paper = Raphael(canvasEl, '100%', '100%');
        setPaper(tmp_paper)
        setCanvasEl(canvasEl)
        resolve(tmp_paper)
      }
    })

  }


  /** Detect attempt to draw a transaction and proceed if on condition */
  const drawTransaction = (paper, canvasEl) => {

    if (paper == null || canvasEl == null) {
      return;
    }


    if (clickEvent != null) {
      canvasEl.removeEventListner('mousedown', 'clickEvent')
      canvasEl.removeEventListner('mousemove', 'mouseMoveEvent')
      canvasEl.removeEventListner('mouseup', 'mouseUpEvent')
    }

    let startPosition = null
    let rectangle = null

    const getOffset = () => {
      const rect = canvasEl.getBoundingClientRect();
      const offset = { top: rect.top + window.scrollY, left: rect.left + window.scrollX };
      return offset;
    };

    /** Mouse click identify */
    clickEvent = canvasEl.addEventListener('mousedown', function (e) {

      if (transactionPaperStatus == false) {
        return false;
      }

      let mouseDownX = e.pageX - getOffset().left;
      let mouseDownY = e.pageY - getOffset().top;
      startPosition = { x: mouseDownX, y: mouseDownY }
    })

    /** Mouse move */
    mouseMoveEvent = canvasEl.addEventListener('mousemove', function (e) {


      if (startPosition == null)
        return false;


      let mouseDownX = e.pageX - getOffset().left;
      let mouseDownY = e.pageY - getOffset().top;

      if (rectangle == null) {
        rectangle = paper.rect(startPosition.x, startPosition.y, mouseDownX - startPosition.x, mouseDownY - startPosition.y)
      } else {
        rectangle.attr({ width: mouseDownX - startPosition.x, height: mouseDownY - startPosition.y })
      }


      rectangle.attr({ fill: 'yellow', opacity: 0.5 })

    })

    /** Mouse up - done drawing transaction */
    mouseUpEvent = canvasEl.addEventListener('mouseup', function (e) {

      try {

        if (startPosition == null || canvasEl == null) {
          return false;
        }

        let newOrder = findOrder(rectangle.attr('y'))
        setNewTransactionOrder(newOrder)

        startPosition = null
        setLastDrawnObject(rectangle)
        dispatch(openTransactionSelectorForSimulation(true))
        canvasEl.removeEventListener('click', clickEvent)
        canvasEl.removeEventListner('mousemove', mouseMoveEvent)
        startPosition = null

      } catch (error) {

        console.error(error)
      }
    }, { once: true })

  }


  // Prepare delegates
  const prepareDelegates = ({delegates, clusterlets, testCaseTransactions}) => {

    // console.log(delegates, 'this is delegates');
    let delegate_node;
    let last_x = nodes[0].x + widthOfNode //200 additional for event displaying    
    
    const clusterletsInSelectedTransactions = [];
    testCaseTransactions.forEach(element => {
      element.clusterlets.forEach(cl => {
          clusterletsInSelectedTransactions.push(cl.id);
      })
    });

   
    let selectedDelegates = delegates.filter(item =>  clusterletsInSelectedTransactions.includes(item.id))

    selectedDelegates.forEach(delegate => {

      delegate_node = {
        id: delegate.id,
        name: clusterlets.find(c => c._id === delegate.id) !== undefined ? clusterlets.find(c => c._id === delegate.id).name : "Not Available",
        x: last_x + widthOfNode + 20,
        y: 20,
        width: widthOfNode,
        height: 70,
        fillColor: '#273e65',
        draggable: false
      }

      last_x = delegate_node.x

      setNodes([...nodes, delegate_node])
    })


  }


  // Prepare transactions
  const prepareTransactions = ({simulationTransactions, allTransactions, filteredSimulationTransactions}) => {


    let second_delegate = nodes[1]
    let last_delegate_x = nodes[nodes.length - 1].x
    let transactionGap = 100
    filteredSimulationTransactions.forEach(s_transaction => {

      let events_in_transaction = events.filter(e => e.rootSimulationTransaction == s_transaction._id)
      let triggerEventsInTransaction = events_in_transaction.filter(e => e.event_type == "request")

      if (Array.isArray(triggerEventsInTransaction) && triggerEventsInTransaction.length === 0) return;

      let first_event_y = events_in_transaction[0]?.y1
      let last_event_y = events_in_transaction[events_in_transaction.length - 1]?.y1

      const transaction = {
        id: s_transaction.transaction_id,
        x: second_delegate.x,
        y: first_event_y ? first_event_y + 10 : transactionGap,
        width: last_delegate_x + nodes[0].width - second_delegate.x,
        height: last_event_y !== first_event_y ? last_event_y - first_event_y - 20 : 30,
        name: allTransactions.find(t => t._id == s_transaction.transaction_id) !== undefined ? allTransactions.find(t => t._id == s_transaction.transaction_id).name : 'Transaction',
        fillColor: '#d7b7ed',
        simulation_transaction_id: s_transaction._id,
        order: s_transaction.order,
        description: s_transaction?.description ? s_transaction.description : ''
      }

      transactionGap += 75

      transactions.push(transaction)

    })
  }


  const prepareChildTransactions = ({simulationTransactions, allTransactions}) => {

    let second_delegate = nodes[1]
    let last_delegate_x = nodes[nodes.length - 1].x


    const childSimulationTransactions = simulationTransactions.filter(sTransaction => {
      const transactionObj = allTransactions.find(transaction => transaction._id.toString() === sTransaction.transaction_id)
      return transactionObj && transactionObj.type === 9;
    });
    
    childSimulationTransactions.sort((a, b) => a.order - b.order);
    
    childSimulationTransactions.forEach(s_transaction => {
      let events_in_transaction = events.filter(e => e.simulation_transaction_id == s_transaction._id)
     
      let first_event_y = events_in_transaction[0]?.y1;
      let last_event_y = events_in_transaction[events_in_transaction.length - 1]?.y1;

      const transactionObj = allTransactions.find(t => t._id == s_transaction.transaction_id);
      
      const name = transactionObj !== undefined ? `${transactionObj.name}${transactionObj.oneof ? " - oneof" : transactionObj.loop ? ` - loop(${s_transaction.loop ? s_transaction.loop : 1})` : transactionObj.condition ? ` - condition(${s_transaction.condition ? "True" : "False"})` : ""}` : 'Child Transaction'

      if (events_in_transaction.length > 0) {
        const childTransactionObj = {
          id: s_transaction.transaction_id,
          x: second_delegate.x + 5,
          y: first_event_y ? first_event_y - (nodeWidth / 4) : 25,
          width: last_delegate_x + nodes[0].width - second_delegate.x - 10,
          height: last_event_y !== first_event_y ? last_event_y - first_event_y + (nodeWidth / 2) : 50,
          name: transactionObj.name,
          label: name,
          fillColor: s_transaction.condition ? '#e9d6f5' : '#f3eaf9',
          simulation_transaction_id: s_transaction._id,
          order: s_transaction.order,
          description: s_transaction?.description ? s_transaction.description : '',
          transactionData: transactionObj
        }
        childTransactions.push(childTransactionObj)
      }
    })

  }

  const prepareInvokedTransactions = ({simulationTransactions, allTransactions}) => {

    let second_delegate = nodes[1]
    let last_delegate_x = nodes[nodes.length - 1].x


    const invokedSimulationTransactions = simulationTransactions.filter(sTransaction => {
      const transactionObj = allTransactions.find(transaction => transaction._id.toString() === sTransaction.transaction_id)
      return transactionObj && transactionObj.type === 7 && sTransaction.parent_id !== undefined;
    });
    
    invokedSimulationTransactions.sort((a, b) => a.order - b.order);
    
    invokedSimulationTransactions.forEach(s_transaction => {
      let events_in_transaction = events.filter(e => e.simulation_transaction_id == s_transaction._id)

      let first_event_y = events_in_transaction[0]?.y1;
      let last_event_y = events_in_transaction[events_in_transaction.length - 1]?.y1;
      const parentSimulationTransaction = simulationTransactions.find(item => item._id.toString() === s_transaction.parent_id);
      if (parentSimulationTransaction) {
        const parentTransaction = allTransactions.find(t => t._id == parentSimulationTransaction.transaction_id);
        if (parentTransaction) {
          const invokedData = parentTransaction.invokedTransactions.find(item => item.id === s_transaction.transaction_id);
          if (invokedData) {
            const transactionObj = allTransactions.find(t => t._id == s_transaction.transaction_id);

            const name = transactionObj !== undefined ? `${transactionObj.name}${invokedData.loop ? ` - loop(${s_transaction.loop ? s_transaction.loop : 1})` : invokedData.condition ? ` - condition(${s_transaction.condition ? "True" : "False"})` : ""}` : 'Invoked Transaction'

            if (events_in_transaction.length > 0) {
              const childTransactionObj = {
                id: s_transaction.transaction_id,
                x: second_delegate.x + 5,
                y: first_event_y ? first_event_y - (nodeWidth / 4) : 25,
                width: last_delegate_x + nodes[0].width - second_delegate.x - 10,
                height: last_event_y !== first_event_y ? last_event_y - first_event_y + (nodeWidth / 2) : 50,
                name: transactionObj.name,
                label: name,
                fillColor: s_transaction.condition ? '#e9d6f5' : '#f3eaf9',
                simulation_transaction_id: s_transaction._id,
                order: s_transaction.order,
                description: s_transaction?.description ? s_transaction.description : '',
                conditionData: invokedData.condition,
                loopData: invokedData.loop
              }
              invokedTransactions.push(childTransactionObj)
            }
          }
        }
      }
    })

  }

  const  sortArrayWithTypeByOrder = (arrayWithOrder, arrayWithType) => {

    const result = arrayWithOrder
        .map(orderItem => {
            const typeItem = arrayWithType.find(typeItem => typeItem.id === orderItem.id);
            return typeItem ? { ...typeItem, order: orderItem.order, parentTransaction: orderItem.parentTransaction } : null;  
        }).filter(item => item !== null);  

    const sortedResult = result.sort((a, b) => a.order - b.order);
    return sortedResult.map(({ order, ...rest }) => rest);
}

  // Prepare events
  const prepareEvents = ({simulationTransactions, filteredSimulationTransactions, simulationDelegates, allTransactions, allEvents, allClusterlets}) => {

    let last_event_y = nodes[0].y + widthOfNode / 2
    let gapBetweenTransactions = 75
    
    filteredSimulationTransactions.forEach(simulation_t => {

      let actualTransaction = allTransactions.find(tr => tr._id === simulation_t.transaction_id)
      let childTransactionEvents = [];
      let childSimulationTransactionEvents = [];
      let invokedTransactionEvents = [];
      let invokedSimulationTransactionEvents = [];
      const childIds = simulation_t.events.filter(item => item.type === 'child_transaction').map(item => item.id);
      const invokedIds = simulation_t.events.filter(item => item.type === 'invoked_transaction').map(item => item.id);
      // Finding the events of child transaction
      actualTransaction.nestedTransactions?.forEach(nested => {
        const transactionObj = allTransactions.find(tr => tr._id.toString() === nested.id);
        if (transactionObj) {
          const childEvents = transactionObj.events.sort((a, b) => a.order - b.order).map((item, index) => ({ ...item, parentTransaction: transactionObj._id.toString(), order: nested.order + index}));
          childTransactionEvents = [...childTransactionEvents, ...childEvents];
        }
        const childSimulationTransactionObj = simulationTransactions.find(item => item.transaction_id === nested.id && childIds.includes(item._id.toString()));
        
        if (childSimulationTransactionObj) {
          const updatedChildSimulationTxnEvents = childSimulationTransactionObj.events?.map(item => ({...item, 
            parentSimulationTransaction : childSimulationTransactionObj._id?.toString(),
            isDisabled: transactionObj.condition && !childSimulationTransactionObj.condition,
            parentCondition: transactionObj.condition
            }));
          childSimulationTransactionEvents = [...childSimulationTransactionEvents, ...updatedChildSimulationTxnEvents];
        }
      });

      actualTransaction.invokedTransactions?.forEach(invoked => {
        const transactionObj = allTransactions.find(tr => tr._id.toString() === invoked.id);
        if (transactionObj) {
          const invokedEvents = transactionObj.events.sort((a, b) => a.order - b.order).map((item, index) => ({ ...item, parentTransaction: transactionObj._id.toString(), order: invoked.order + index}));
          invokedTransactionEvents = [...invokedTransactionEvents, ...invokedEvents];
        }
       
        const invokedSimulationTransactionObj = simulationTransactions.find(item => item.transaction_id === invoked.id && invokedIds.includes(item._id.toString()));
        if (invokedSimulationTransactionObj) {
          const updatedInvokedSimulationTxnEvents = invokedSimulationTransactionObj.events?.map(item => ({...item, 
            parentSimulationTransaction : invokedSimulationTransactionObj._id?.toString(),
            isDisabled: invoked.condition && !invokedSimulationTransactionObj.condition,
            parentCondition: invoked.condition
          }))
          invokedSimulationTransactionEvents = [...invokedSimulationTransactionEvents, ...updatedInvokedSimulationTxnEvents];
        }
      });
      let orderdEvents = [...actualTransaction.events, ...childTransactionEvents, ...invokedTransactionEvents].sort(function (a, b) {
        return a.order - b.order;
      });

      let simulation_events = [...simulation_t.events, ...childSimulationTransactionEvents, ...invokedSimulationTransactionEvents].sort(function (a, b) {
        return a.order - b.order;
      });

      let isResponseEventExist = false;
      let isTriggerEventExist = false;

      let finalArrayList = sortArrayWithTypeByOrder(orderdEvents, simulation_events)
      
      finalArrayList.forEach(e => {
        if (e.id === undefined) {
          return;
        }

        let master_event = allEvents.find(all_e => all_e._id === e.id)
        let event_source = allClusterlets.find(c => c._id === master_event.src)
        let event_destination = allClusterlets.find(c => c._id === master_event.dst)
        let x1;
        let x2;
        let event_type;

        // console.log("master_event", { master_event, event_source, event_destination, nodes })


        if (event_source === undefined || (event_source &&  event_source.type !== 1)) {
          //its a response
          if ( nodes.find(node => node.id === event_destination?._id) === undefined) {
            return;
          }

          x1 = event_destination ? nodes.find(node => node.id === event_destination._id).x : null;
          x2 = nodes[0].x
          event_type = 'response'
          isResponseEventExist = true;
        } else if (event_destination === undefined || event_destination?.type !== 1) {
          //its a trigger
          if (nodes.find(node => node.id === event_source._id) === undefined) return

          x1 = nodes.length > 0 ? nodes[0].x : null // trigger it from simulator node,
          x2 = nodes.find(node => node.id === event_source._id) ? nodes.find(node => node.id === event_source._id).x : null;
          event_type = 'request'
          isTriggerEventExist = true;
        }


        const endpoint = findEndpointForTheEvent({event: e, source: event_source, destination: event_destination, event_type});

        const event = {
          id: master_event._id,
          name: master_event !== undefined ? master_event.name : 'Event',
          x1: x1 + nodeWidth,
          y1: last_event_y,
          x2: x2 + nodeWidth,
          y2: last_event_y,
          transaction: e.parentTransaction ? e.parentTransaction : simulation_t.transaction_id,
          simulation_transaction_id: e.parentSimulationTransaction ? e.parentSimulationTransaction : simulation_t._id,
          rootSimulationTransaction: simulation_t._id, // To get the first & last event of the transaction
          isDisabled: e.isDisabled,
          parentCondition: e.parentCondition,
          event_type, 
          endpoint
        }

        if(event?.event_type === "request"){
          event.x1 = event.x1 + endpoint_width/2 ;
        }else{
          event.x2 = event.x2 + endpoint_width/2 + 4;
        }


        last_event_y += gapBetweenTransactions
        if(event_source && event_destination) events.push(event)
      })
      if (!isResponseEventExist || !isTriggerEventExist) {
        last_event_y += gapBetweenTransactions;
      }
    })

  }

  // Finding the endpoints for the event
  const findEndpointForTheEvent = ({event, source, destination, event_type}) => {
      try {
        
        let network = null;

        if(event_type === 'request'){
          network  = networks?.find(net => net._id.toString() === source?.attributes?.network)
        }else{
          network = networks?.find(net => net._id.toString() === destination?.attributes?.network)
        }

        console.log({network})
        let endpoint = network?.name || null;
        return endpoint;
        
      } catch (error) {
        console.error("Finding endpoint for the event failed. ", error);
        return null;
      }
  }


  // Get simulation details
  const getSimulationDetails = async () => {

    let constructs = await dispatch(invokeGetService('getBlueprintConstructs', []))
    let testcase = null;
    let testcasetransactions = [];
    const testcasesList = getTestcasesForListing(constructs?.data?.testCases)
    const sortedTestCases = testcasesList.sort((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });
    setTestcasesforList(sortedTestCases?.sort((a,b) => a?.order - b?.order))

    if (sortedTestCases?.length > 0) {
      if (!testcaseId) {
        setPreviousTestcaseId(sortedTestCases?.[0]._id)
        history.push({
          pathname,
          search: `?testcase=${sortedTestCases?.[0]._id}`
        })
      } else {
        setPreviousTestcaseId(testcaseId)
      }
      testcase = await dispatch(invokeGetService('getTestcaseData', [testcaseId || sortedTestCases?.[0]._id]))
      testcasetransactions  = await dispatch(invokeGetService('getTestcaseTransactions', [testcaseId || sortedTestCases?.[0]._id]))
    } else {
      history.push({
        pathname,
        search: ""
      })
    }

    return [constructs, testcase, testcasetransactions]

  }

  // Inject simulator Node
  const prepareSimulatorNode = () => {
    const simulatorNode = {
      name: 'Simulator',
      x: 20,
      y: 20,
      width: widthOfNode,
      height: 70,
      fillColor: '#3a5c95',
      stroke: '#3a5c95',
      draggable: false
    }
    setNodes([...nodes, simulatorNode])

  }

  // Set nodes
  const setNodes = updated_nodes => {
    nodes = updated_nodes
  }


  // Render nodes
  const renderNodes = () => {
    if (paper == null) {
      // console.log('paper is null node')
      return false
    }



    nodes.forEach(node => {
      let attributes = {fill: node.fillColor }
      if(node?.name == "Simulator") attributes.stroke = node?.stroke;

      paper.rect(node.x, node.y, node.width, node.height, 10).attr(attributes)

      if (node.draggable) {
        paper.rect(node.x, node.y + node.height, node.width, 30).attr({ fill: '#ccc' })
      }

      let verticalLine = paper.path(`M${node.x + (node.width) / 2} ${node.y + node.height}L${node.x + (node.width) / 2} ${verticalLineMinHeight}`)

      let verticalLineObj = {
        x1: node.x + (node.width) / 2,
        y1: node.y + node.height,
        x2: node.x + (node.width) / 2,
        y2: verticalLineMinHeight,
        raphaelobj: verticalLine
      }

      drawnVerticalLines.push(verticalLineObj)

      if (node.name !== undefined) {
        paper.text(node.x + (node.width) / 2, node.y + (node.height) / 2, node.name).attr({ fill: '#fff', size: 22 })
      }
    })
  }

  function wrapText(paper, text, x, y, maxWidth) {
    const words = text.split(' ');
    let line = '';
    let lineHeight = 16; // Adjust this value as needed for line height
    let tspan;

    words.forEach((word) => {
        const tempLine = line + word + ' ';
        const tempText = paper.text(x, y, tempLine).attr({ 'text-anchor': 'start' });

        if (tempText.getBBox().width > maxWidth) {
            tspan = paper.text(x, y, line.trim()).attr({ 'text-anchor': 'start' });
            y += lineHeight; // Move down to the next line
            line = word + ' '; // Start new line with the current word
        } else {
            line = tempLine;
        }
        
        tempText.remove(); // Remove temporary text element
    });

    // Add the last line
    tspan = paper.text(x, y, line.trim()).attr({ 'text-anchor': 'start' });
}

  // Render transactions
  const renderTransactions = () => {

    if (paper == null) {
      // console.log('paper is null node')
      return false
    }

    /** Draw transactions and assoicated vectors */
    transactions.forEach(tr => {

      
      let t_drawn = paper.rect(tr.x, tr.y, tr.width, tr.height);
      
      if(tr?.description) {
        t_drawn.attr({ title: `${tr?.description ? tr.description: ''}`, cursor: 'pointer' }).toFront()
      }else{
        t_drawn.attr({ title: 'No description available', cursor: 'pointer' }).toFront()
      }


      if (tr.fillColor !== undefined) {
        t_drawn.attr({ fill: tr.fillColor, 'fill-opacity': 0.8 })
      }



      if (tr.name !== undefined) {

        const tr_label = paper.text(tr.x + tr.width - 120, tr.y + 10, tr.name).attr({ ...translabelAttributes, title: `Click to open configuration for ${tr.name}` }).toFront()
        const tr_label_box = tr_label.getBBox()

        // const tr_description = paper.text(tr.x + 100, tr.y + tr.height - 10, tr?.description ? tr.description : '').toFront()
        // const tr_description_box = tr_description.getBBox()

        wrapText(paper, tr?.description ? tr.description : '', tr.x+5, tr.y + tr.height - 25, 190)

        const tr_label_rectangle = paper.rect(tr_label_box.x - 10, tr_label_box.y, tr_label_box.width + 20, tr_label_box.height + 2).attr({ ...nestedTransactionLabelConfig, title: tr.name, class: 'simulationTransaction' })
        const tr_label_extra = paper.text(tr.x + tr.width - 120, tr.y + 10, tr.name).attr({ ...translabelAttributes, title: `Click to open configuration for ${tr.name}` }).toFront()


        if (tr_label_box.y > verticalLineMinHeight) {
          let newYPos = tr_label_box.y + tr_label_box.height + offsetDistance;

          setCanvasHeight(newYPos + appendHeight);

          drawnVerticalLines.forEach(vLine => {
            vLine.raphaelobj.attr('path', `"M${vLine.x1},${vLine.y1}L${vLine.x2},${newYPos + appendHeight}"`);
          })

        }

        tr_label_rectangle.click(function () {
          openTransactionConfig(tr)
        });

        tr_label.click(function () {
          openTransactionConfig(tr)
        });

        tr_label_extra.click(function () {
          openTransactionConfig(tr)
        })


        drawnTrs.push({ id: tr.id, drawnObj: t_drawn, order: tr.order, name: tr.name, tr_label, tr_label_rectangle, tr_label_extra, simulation_transaction_id: tr.simulation_transaction_id })
        setDrawnTransactions(drawnTrs)
      }

    })

    /** Open transaction configuration */
    function openTransactionConfig(tr) {
      handleRightDrawer()
      dispatch(setFocusElement({ simulation_transaction_id: tr.simulation_transaction_id, type: 'simulationTransaction', name: tr.name, testcase_id: testcaseId }));
    }



    setDrawnTransactions(drawnTrs)

  }

  const renderChildTransactions = (testCaseName) => {

    if (paper == null) {
      return false
    }


    /** Draw child transactions*/
    childTransactions.forEach(tr => {
      let child_drawn = paper.rect(tr.x, tr.y, tr.width, tr.height);
      
      if(tr?.description) {
        child_drawn.attr({ title: `${tr?.description ? tr.description: ''}`, cursor: 'pointer' }).toFront()
      }else{
        child_drawn.attr({ title: 'No description available', cursor: 'pointer' }).toFront()
      }

      if (tr.fillColor !== undefined) {
        child_drawn.attr({ fill: tr.fillColor, 'fill-opacity': 0.8 })
      }

      if (tr.name !== undefined) {
        const isClickable = tr.transactionData?.condition != null || tr.transactionData?.loop != null;
        const attributesOfLabel = isClickable ? {...translabelAttributes, title: `Click to configure ${tr.transactionData?.condition != null ? "Condition" : "Loop"}`} : {...translabelAttributes, title: `Condition/Loop configuration is not available`, cursor: 'not-allowed'};
        const tr_label = paper.text(tr.x + tr.width - 120, tr.y + 10, tr.label).attr({ ...attributesOfLabel }).toFront()
        const tr_label_box = tr_label.getBBox()
        
        wrapText(paper, tr?.description ? tr.description : '', tr.x+5, tr.y + tr.height - 25, 190)

        const tr_label_rectangle = paper.rect(tr_label_box.x - 10, tr_label_box.y, tr_label_box.width + 20, tr_label_box.height + 2).attr({ ...nestedTransactionLabelConfig, title: tr.label, class: 'simulationTransaction' })
        const tr_label_extra = paper.text(tr.x + tr.width - 120, tr.y + 10, tr.label).attr({ ...attributesOfLabel }).toFront()


        if (tr_label_box.y > verticalLineMinHeight) {
          let newYPos = tr_label_box.y + tr_label_box.height + offsetDistance;

          drawnVerticalLines.forEach(vLine => {
            vLine.raphaelobj.attr('path', `"M${vLine.x1},${vLine.y1}L${vLine.x2},${newYPos}"`);
          })

        }
        
        if (isClickable) {
          tr_label_rectangle.click(function () {
            handleRightDrawer();
            dispatch(setFocusElement({ item: tr, testcase_name: testCaseName, simulation_transaction_id: tr.simulation_transaction_id, type: 'childSimulationTransaction', name: tr.name, testcase_id: testcaseId, conditionFlag: tr.transactionData?.condition ? true : false, loopFlag: tr.transactionData?.loop ? true : false }));
          });
  
          tr_label.click(function () {
            handleRightDrawer();
            dispatch(setFocusElement({ testcase_name: testCaseName, simulation_transaction_id: tr.simulation_transaction_id, type: 'childSimulationTransaction', name: tr.name, testcase_id: testcaseId, conditionFlag: tr.transactionData?.condition ? true : false, loopFlag: tr.transactionData?.loop ? true : false }));
          });
  
          tr_label_extra.click(function () {
            handleRightDrawer();
            dispatch(setFocusElement({ testcase_name: testCaseName, simulation_transaction_id: tr.simulation_transaction_id, type: 'childSimulationTransaction', name: tr.name, testcase_id: testcaseId, conditionFlag: tr.transactionData?.condition ? true : false, loopFlag: tr.transactionData?.loop ? true : false }));
          })
        }

        drawnChildTransactions.push({ id: tr.id, drawnObj: child_drawn, order: tr.order, name: tr.name, tr_label, tr_label_rectangle, tr_label_extra, simulation_transaction_id: tr.simulation_transaction_id })
      }

    });

  }


  const renderInvokedTransactions = (testCaseName) => {

    if (paper == null) {
      return false
    }


    /** Draw invoked transactions*/
    invokedTransactions.forEach(tr => {
      let child_drawn = paper.rect(tr.x, tr.y, tr.width, tr.height);
      
      if(tr?.description) {
        child_drawn.attr({ title: `${tr?.description ? tr.description: ''}`, cursor: 'pointer' }).toFront()
      }else{
        child_drawn.attr({ title: 'No description available', cursor: 'pointer' }).toFront()
      }

      if (tr.fillColor !== undefined) {
        child_drawn.attr({ fill: tr.fillColor, 'fill-opacity': 0.8 })
      }

      if (tr.name !== undefined) {
        const isClickable = tr.conditionData != null || tr.loopData != null;
        const attributesOfLabel = isClickable ? {...translabelAttributes, title: `Click to configure ${tr.conditionData ? "Condition" : "Loop"}`} : {...translabelAttributes, title: `Condition/Loop configuration is not available`, cursor: 'not-allowed'};
        const tr_label = paper.text(tr.x + tr.width - 120, tr.y + 10, tr.label).attr({ ...attributesOfLabel }).toFront()
        const tr_label_box = tr_label.getBBox()

        wrapText(paper, tr?.description ? tr.description : '', tr.x+5, tr.y + tr.height - 25, 190)

        const tr_label_rectangle = paper.rect(tr_label_box.x - 10, tr_label_box.y, tr_label_box.width + 20, tr_label_box.height + 2).attr({ ...nestedTransactionLabelConfig, title: tr.label, class: 'simulationTransaction' })
        const tr_label_extra = paper.text(tr.x + tr.width - 120, tr.y + 10, tr.label).attr({ ...attributesOfLabel}).toFront()


        if (tr_label_box.y > verticalLineMinHeight) {
          let newYPos = tr_label_box.y + tr_label_box.height + offsetDistance;

          drawnVerticalLines.forEach(vLine => {
            vLine.raphaelobj.attr('path', `"M${vLine.x1},${vLine.y1}L${vLine.x2},${newYPos}"`);
          })

        }

        if (isClickable) {
          tr_label_rectangle.click(function () {
            handleRightDrawer();
            dispatch(setFocusElement({ testcase_name: testCaseName, item: tr, simulation_transaction_id: tr.simulation_transaction_id, type: 'childSimulationTransaction', name: tr.name, testcase_id: testcaseId, conditionFlag: tr.conditionData ? true : false, loopFlag: tr.loopData ? true : false }));
          });
  
          tr_label.click(function () {
            handleRightDrawer();
            dispatch(setFocusElement({ testcase_name: testCaseName, simulation_transaction_id: tr.simulation_transaction_id, type: 'childSimulationTransaction', name: tr.name, testcase_id: testcaseId, conditionFlag: tr.conditionData ? true : false, loopFlag: tr.loopData ? true : false  }));
          });
  
          tr_label_extra.click(function () {
            handleRightDrawer();
            dispatch(setFocusElement({ testcase_name: testCaseName, simulation_transaction_id: tr.simulation_transaction_id, type: 'childSimulationTransaction', name: tr.name, testcase_id: testcaseId, conditionFlag: tr.conditionData ? true : false, loopFlag: tr.loopData ? true : false  }));
          })
        }


        drawnInvokedTransactions.push({ id: tr.id, drawnObj: child_drawn, order: tr.order, name: tr.name, tr_label, tr_label_rectangle, tr_label_extra, simulation_transaction_id: tr.simulation_transaction_id })
      }

    });

  }

  const getCurrentRigthdrawerStatus = () => {
    try {

      return new Promise((resolve, reject) => {

        let watchStore = watch(store.getState, 'global');

        const unsubscribe = store.subscribe(
          watchStore(() => {
            const currentDrawerStatus = store.getState()?.global?.rightDrawerStatus;
            resolve(currentDrawerStatus);
            unsubscribe();  // Unsubscribe to avoid memory leaks

          })
        );

        // Add a timeout to reject the promise if the state doesn't update in time
        setTimeout(() => {
          reject(new Error('Failed to get the drawer status in time.'));
          unsubscribe();
        }, 5000);  // Adjust the timeout as necessary

      });


    } catch (error) {
      console.error(error)
    }
  };

  const handleRightDrawer = async () => {
    try {
      const currentDrawerStatus = await getCurrentRigthdrawerStatus();
      if (!currentDrawerStatus) {
        dispatch(toggleRightDrawer());
      }
    } catch (error) {
      console.error('Error while getting right drawer status:', error.message);
    }
  };

  const bringEventToTop = () => {
    drawnEvents.forEach(ev => {
      ev?.event_drawn.toFront();
      ev?.label_rectangle.toFront();
      ev?.event_name.toFront();
    })
  }

  const bringEndpointsToTop = () => {
    drawnEndpoints?.forEach(endpoint => {
      endpoint?.label_rectangle.toFront();
      endpoint?.endpoint_name.toFront();
    })
  }


  // Render events
  const renderEvents = () => {

    console.log("events:", events)
    for (let i = 0; i < events.length; i++) {
      let event = events[i];
      
      const lineAttributes = event.isDisabled ? disabledEventAttributes : eventAttributes;
      const event_drawn = paper.path(`M${event.x1} ${event.y1}L${event.x2} ${event.y2}`).attr(lineAttributes)
      event_drawn.node.setAttribute('data-ui-tour-id', 'drawen-event');

      if (event.event_type == 'request') {
        event_drawn.attr({ "arrow-end": "classic-wide-long" })
      } else if (event.event_type == 'response') {
        event_drawn.attr({ "arrow-end": "classic-wide-long" })
      }

      if (event.name !== undefined) {
        const text_start_x = event.x1 + (event.x2 - event.x1) / 2
        const text_start_y = event.y1 - 10;
        const attributedOfLabel = event.isDisabled ? {...labelAttributes, title: `Not applicable. Condition ${event.parentCondition ? event.parentCondition : ""} is set to false`} : labelAttributes;
        const event_name = paper.text(text_start_x, text_start_y, event.name).attr(attributedOfLabel);
        
        const label_box = event_name.getBBox()
        
       
        const label_rectangle = paper.rect(label_box.x - 10, label_box.y - 2, label_box.width + 20, label_box.height + 2).attr(event.isDisabled ? disabledNestedTransactionLabelConfig : nestedTransactionLabelConfig).toBack()

        if (!event.isDisabled) {
          label_rectangle.click(function () {
            // console.log("eventpayload click")
            handleRightDrawer()
            dispatch(setFocusElement({ id: event.id, type: 'eventPayload', name: event.name, simulation_transaction_id: event.simulation_transaction_id }));
  
          })
  
          event_name.click(function () {
            // console.log("eventpayload click------------")
            handleRightDrawer()
            dispatch(setFocusElement({ id: event.id, type: 'eventPayload', name: event.name, simulation_transaction_id: event.simulation_transaction_id }));
  
          })
        }

        drawnEvents.push({
          event_drawn,
          event_name,
          label_box,
          label_rectangle
        })

      }

      // })
    }
  }

  // Render endpoints
  const renderEndpoints = () => {
    try {
      
      const sim_node = nodes?.find(item => item?.name === "Simulator")
      
      for(let i=0; i<events?.length; i++){
        let event = events[i];
        let isEndpointAvailable = event.endpoint ? true : false;
        console.log({isEndpointAvailable})
        let endpoint_title = event?.endpoint || "";
        let endpoint = event.endpoint || "No network";
        let endpoint_rect_class = `endpoint_${event.name}_${endpoint}`
        let endpoint_text_class = `endpoint_${event.name}_${endpoint}_text`
      
        const text_start_x = sim_node.x + nodeWidth
        const text_start_y = event.y1

        const endpoint_name = paper.text(text_start_x, text_start_y, endpoint).attr({...endPointLabelAttributes, title: endpoint_title})
        endpoint_name.node.setAttribute('class', endpoint_text_class)
        const label_box = endpoint_name.getBBox();
        

        // Truncate the text if it exceeds the max width
        while (endpoint_name.getBBox().width > endpoint_width-10 && endpoint.length > 0) {
          endpoint = endpoint.slice(0, -1); // Remove the last character
          endpoint_name.attr("text", endpoint + "…"); // Add ellipsis
          endpoint_name.attr("title", endpoint_title);
        }

        const label_rectangle = paper.rect(text_start_x - endpoint_width/2, label_box.y-3 , endpoint_width, label_box.height + 6).attr(event.isDisabled ? {...disabledEndpointRectangleConfig, title: endpoint_title } : {...endpointRectangleConfig, title: endpoint_title}).toBack()
        label_rectangle.node.setAttribute('class', endpoint_rect_class)

        if(!isEndpointAvailable){
          endpoint_name.attr({
            title: "No network configured"
          })
          label_rectangle.attr({
            fill: '#c23206',
            stroke: '#c23206',
            title: "No network configured"
          })
        }

        drawnEndpoints.push({
          endpoint_name,
          label_box,
          label_rectangle
        })
      }


    } catch (error) {
      console.error("Rendering endpoints failed. ", error);
    }
  }

  // Remove last drawn Raphael object in case of cancelling
  const removeLastDrawnObject = () => {

    if (lastDrawnObject != null) {
      lastDrawnObject.remove()
    }
  }

  /** Find new order of a re-ordered transaction or newly created transaction */
  const findOrder = (yPosition, reorderedTransaction) => {

    try {

      if (drawnTrs.length == 0) drawnTrs = drawnTransactions

      let nextTransaction = drawnTrs.find(tr => tr.drawnObj.attr('y') > yPosition && tr.simulation_transaction_id !== reorderedTransaction)
      // console.log({ nextTransaction, yPosition, drawnTrs })
      if (nextTransaction === undefined) {
        //Moved to bottom, so there's no next higher transaction
        //Just add 1 to the last order
        return drawnTrs[drawnTrs.length - 1].order + 1
      } else {
        let nextTransactionIndex = drawnTrs.findIndex(tr => tr.drawnObj.attr('y') > yPosition && tr.simulation_transaction_id !== reorderedTransaction)
        // console.log({ nextTransactionIndex })
        if (drawnTrs[nextTransactionIndex - 1] !== undefined) {
          //There's a previous transaction
          let newOrder = drawnTrs[nextTransactionIndex - 1].order + (drawnTrs[nextTransactionIndex].order - drawnTrs[nextTransactionIndex - 1].order) / 2
          return newOrder
        } else {
          //Moved to the top
          return drawnTrs[nextTransactionIndex].order / 2
        }
      }

    } catch (error) {
      console.error('Error while reordering the transaction', error)
      return false
    }

  }


  /** Attach drag functionality to transactions */
  const attachTransactionDragHandlers = () => {

    drawnTrs.forEach(tr => {
      const dragHandle = paper.image(`${process.env.PUBLIC_URL}/dragImage1.png`, tr.drawnObj.attr('x'), tr.drawnObj.attr('y'), 20, 20).attr({ ...dragHandler, title: 'Move transaction vertically' });

      // console.log('loop', tr)

      dragHandle.drag((x, y, dx, dy, e) => transactionDragInMove(tr.drawnObj, dragHandle, tr.tr_label_rectangle, tr.tr_label, tr.tr_label_extra, e), transactionDragInStart, () => transactionDragInEnd(tr.drawnObj, tr.simulation_transaction_id))

    })


    /** Drag transaction - move */
    function transactionDragInMove(movedTr, dragHandle, transactionLabelBox, transactionLabel, transactionLabelExtra, e) {

      try {

        const getOffset = () => {
          const canvasEl = document.getElementById('simulation_container');
          const rect = canvasEl.getBoundingClientRect();
          const offset = { top: rect.top + window.scrollY, left: rect.left + window.scrollX };
          return offset;
        };

        //let newY = e.clientY - 100 //100 seems to be the right one, when its 100, both mouse cursor and element is on the same position. Dont know why. Please feel free to experiment
        let newY = e.clientY - getOffset().top
        dragHandle.attr({ y: newY })
        movedTr.attr({ y: newY, fill: 'yellow' })
        transactionLabelBox.attr({ y: newY - 10 })
        transactionLabel.attr({ y: newY + 1 })
        transactionLabelExtra.attr({ y: newY + 1 })
      } catch (error) {
        console.error(movedTr)
      }
    }

    /** Drag transaction - start */
    function transactionDragInStart() {
      //so far nothing
    }

    /** Drag transaction - end */
    async function transactionDragInEnd(movedTr, movedTrID) {

      try {

        let newOrder = findOrder(movedTr.attr('y'), movedTrID)
        let payloadForOrderUpdate = { simulationTransactionId: movedTrID, order: newOrder, simulationId: entityId }

        dispatch(invokePostService('updateSimulationTransactionOrder', payloadForOrderUpdate, [testcaseId]))
          .then(response => {
            if (response.status) {
              dispatch(handleSnackBar({ open: true, message: response.message, severity: 'success' }))
            } else {
              dispatch(handleSnackBar({ open: true, message: response.message, severity: 'error' }))
            }

            dispatch(setReRender())
          }).catch(error => {
            console.error(error);
          })



      } catch (error) {
        console.error(error)
        dispatch(handleSnackBar({ open: true, message: 'Could not reorder the transaction', severity: 'error' }))
        dispatch(setReRender())
      }
    }
  }

  const handleCreateTestcase = () => {
    dispatch(setFocusElement({ type: 'simulation_testcases', id: null, action: 'create', name: `Create Testcase`, activeTestsuite }))
    dispatch(toggleRightDrawer())
  }

  return (
    <div style={styles.container}>
      {(testcaseId) ?
        <div id="testsuite_window" style={styles.twoColumnLayout}>
          {
            testcasesforList?.length > 0 &&
            <TestCaseLists list={testcasesforList} setTestcasesforList={setTestcasesforList} testsuites={testsuites} isExpanded={isExpanded} />
          }
          {
            !isLoading ?
              <div style={{ position: 'relative' }}>
                <Button data-ui-tour-id="expand-btn" style={styles.expCollapseBtn} id="expand_collapse_diagram" onClick={() => setExpanded((prev) => !prev)}>
                  {isExpanded ? 'Collapse' : 'Expand'}
                  {
                    isExpanded ?
                      <FullscreenExitIcon />
                      :
                      <FullscreenIcon />
                  }
                </Button>
                <div id="simulation_container" style={styles.canvas}></div>
              </div>

              :
              <div style={{ width: '100%' }}>
                <LoaderWithProgress isLoader={true} styleRoot={{ overflow: "hidden", height: window.innerHeight - (64 + 48 + 30) }} />
              </div>

          }

        </div>

        : !isLoading && !testcaseId ?
          <div style={{ ...styles.createTestcaseContainer }} id="testsuite_window">
            <Alert severity="info">No testcases available in the testsuite</Alert>
            <Button style={{ background: '#353F51', color: 'white', padding: '0.5rem 1rem', textTransform: 'capitalize' }} onClick={handleCreateTestcase}>Create Testcase</Button>
          </div>
          :
          null
      }
      {/* {isLoading && <LoaderWithProgress isLoader={true} styleRoot={{ overflow: "hidden", height: window.innerHeight - (64 + 48 + 30) }} />} */}
      {/* {
        testcaseId &&
        <SimulationSpeedDial onStart={() => { setTransactionPaperStatus(Math.random()) }} />
      } */}
      {transactionSelectorStatus &&
        <SingleTransactionSelector key={transactionPaperStatus} onClose={() => { removeLastDrawnObject() }} order={newTransactionOrder} />
      }
    </div>
  );
};

export default Simulation;